/*
 * Copyright (c) 2022. Nedaware SL
 */

import {BasicEntity, BasicProperty} from '../../basic-entity-back/annotations';
import {Persona} from './persona.model';
import {PropertyType} from '../../basic-entity-back/property-type/property-type';
import {ManagerCachingStrategy, SearchType} from '../../basic-entity-back/basic-entity-interface/mapping-external';
import {RangeFilters} from '../../basic-entity-back/filters/range-filters';
import {NumericFilter} from '../../basic-entity-back/filters/numeric-filter';
import {BooleanFilter} from '../../basic-entity-back/filters/boolean-filter';
import {PersonaContacto} from "./contacto.model";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {DescuentoCliente} from "../trabajos/descuento-cliente.model";
import {PrioridadEnvio} from "../envios/prioridad-envio.model";

@BasicEntity({
    name: 'Clientes',
    endpoint: 'clientes',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'nombreCompleto',
    acceptsBulkIriSearch: true,
    type: 'Cliente',
    managerCaching: ManagerCachingStrategy.NoCache
})

export class Cliente extends Persona {
    @BasicProperty({
        name: 'Nombre / Razón Social',
        type: PropertyType.String(),
        sortable: true
    })
    private _denominacionSocial;

    @BasicProperty({
        name: 'Empresa',
        type: PropertyType.Boolean(),
        filters: [BooleanFilter],
    })
    private _empresa: boolean = false;

    @BasicProperty({
        name: 'Intracomunitaria',
        type: PropertyType.Boolean(),
        searchable: SearchType.Boolean
    })
    private _intracomunitaria: boolean = false;

    @BasicProperty({
        name: 'Saldo',
        type: PropertyType.NestedModel(PersonaContacto, undefined, NestedBehavior.CreateOnly),
        array: true
    })
    private _contactos;

    @BasicProperty({
        name: 'Prioridad para envío',
        type: PropertyType.NestedModel(PrioridadEnvio, null, NestedBehavior.SendIriOnly),
        order: 19
    })
    private _prioridadEnvio: PrioridadEnvio;

    @BasicProperty({
        name: 'Descuentos por método de fabricación',
        tag: 'Descuentos',
        type: PropertyType.NestedModel(DescuentoCliente),
        array: true
    })
    private _descuentosMetodoFabricacion = [];

    @BasicProperty({
        name: 'Activado',
        type: PropertyType.Boolean(),
        order: 10
    })
    private _activado: boolean = false;

    get denominacionSocial() {
        return this._denominacionSocial;
    }

    set denominacionSocial(value) {
        this._denominacionSocial = value;
    }


    get intracomunitaria(): boolean {
        return this._intracomunitaria;
    }

    set intracomunitaria(value: boolean) {
        this._intracomunitaria = value;
    }


    get empresa(): boolean {
        return this._empresa;
    }

    set empresa(value: boolean) {
        this._empresa = value;
    }

    get contactos() {
        return this._contactos;
    }

    set contactos(value) {
        this._contactos = value;
    }

    get datosCliente(): string {
        let segundaLinea = '';
        if (this.email) {
            segundaLinea = `${this.email}`;
        }
        return segundaLinea;
    }

    get matIcon(): string {
        if (this.empresa) {
            return 'business';
        }
        return 'person';
    }

    get matIconColor(): string {
        if (this.usuario) {
            if (this.usuario.enabled) {
                return 'primary';
            }
            return 'black';
        }
    }

    get prioridadEnvio(): PrioridadEnvio {
        return this._prioridadEnvio;
    }

    set prioridadEnvio(value: PrioridadEnvio) {
        this._prioridadEnvio = value;
    }

    get descuentosMetodoFabricacion() {
        return this._descuentosMetodoFabricacion;
    }

    set descuentosMetodoFabricacion(value) {
        this._descuentosMetodoFabricacion = value;
    }

    get activado(): boolean {
        return this._activado;
    }
    set activado(value: boolean) {
        this._activado = value;
    }
}

DescuentoCliente.MAP_CLIENTE.type = PropertyType.Uri(Cliente);
